export const ANALYTICS_CONSENT_COOKIE = 'lm_analytics_consent';
export const ANALYTICS_CONSENT_STORAGE_KEY = 'cookieConsent';
export const ANALYTICS_CONSENT_EVENT = 'analytics-consent-changed';

export type AnalyticsConsent = 'accepted' | 'declined' | null;

const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

export function readAnalyticsConsent(): AnalyticsConsent {
  if (typeof window === 'undefined') return null;

  const stored = window.localStorage.getItem(ANALYTICS_CONSENT_STORAGE_KEY);
  if (stored === 'accepted' || stored === 'declined') {
    syncConsentCookie(stored);
    return stored;
  }
  return null;
}

/** Keep the server-readable consent cookie aligned with an existing localStorage choice. */
function syncConsentCookie(consent: Exclude<AnalyticsConsent, null>): void {
  const expected = consent === 'accepted' ? 'granted' : 'denied';
  const current = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${ANALYTICS_CONSENT_COOKIE}=`))
    ?.split('=')[1];

  if (current === expected) return;

  document.cookie = [
    `${ANALYTICS_CONSENT_COOKIE}=${expected}`,
    'Path=/',
    `Max-Age=${ONE_YEAR_SECONDS}`,
    'SameSite=Lax',
    ...(window.location.protocol === 'https:' ? ['Secure'] : []),
  ].join('; ');
}

export function writeAnalyticsConsent(consent: Exclude<AnalyticsConsent, null>): void {
  if (typeof window === 'undefined') return;

  window.localStorage.setItem(ANALYTICS_CONSENT_STORAGE_KEY, consent);
  syncConsentCookie(consent);

  window.dispatchEvent(
    new CustomEvent(ANALYTICS_CONSENT_EVENT, { detail: { consent } })
  );
}
